import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, homeForRole } from "@/context/AuthContext";

export default function AuthCallback() {
  const { exchangeGoogle } = useAuth();
  const navigate = useNavigate();
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    window.history.replaceState(null, "", window.location.pathname);
    if (!sessionId) { navigate("/login", { replace: true }); return; }
    (async () => {
      try {
        const u = await exchangeGoogle(sessionId);
        navigate(u.needs_profile ? "/completer-profil" : homeForRole(u.role), { replace: true });
      } catch {
        setError("Échec de la connexion Google.");
        setTimeout(() => navigate("/login", { replace: true }), 1500);
      }
    })();
  }, [exchangeGoogle, navigate]);

  return (
    <div className="min-h-screen bg-[#0F172A] flex items-center justify-center text-white">
      <div className="text-center">
        <div className="w-12 h-12 rounded-lg bg-[#C85A32] flex items-center justify-center text-white font-display font-black text-2xl mx-auto mb-4 animate-pulse">T</div>
        <p>{error || "Connexion en cours..."}</p>
      </div>
    </div>
  );
}
